import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';
import { getCurrentUTCTime } from '../../../__legacy__/helpers/date.helpers';
import { Plan } from '../../../__legacy__/modules/user/user.store';
import { IWorkspace, WorkspaceRole } from '../../../__legacy__/modules/workspaces/workspaces.store';

export interface ICurrentWorkspaceStore {
  readonly currentWorkspace: IWorkspace;
  readonly currentWorkspaceTime: Date;
  isInRole: (roles: WorkspaceRole[]) => boolean;
  setCurrentWorkspace: (selectedWorkspace: IWorkspace) => void;
}

export namespace ICurrentWorkspaceStore {
  export const $: interfaces.ServiceIdentifier<ICurrentWorkspaceStore> = Symbol('CURRENT_WORKSPACE_STORE');
}

@injectable()
export class CurrentWorkspaceStore implements ICurrentWorkspaceStore {
  currentWorkspace: IWorkspace = {
    name: '',
    id: '',
    role: WorkspaceRole.Owner,
    locked: false,
    encryption: { encrypted: false, encryptionAllowed: false },
    ownerPlanTier: Plan.Free,
    timeZoneOffset: 0,
    ownerEmail: '',
    ownerPlanInfo: {
      plan: Plan.Free,
      limits: {
        maxStorageInGB: 0,
        maxWorkspaces: 0,
        maxWorkspaceUsers: 0,
      },
      usedLimits: {
        usedStorageInGB: 0,
        usedWorkspaces: 0,
        usedWorkspaceUsers: 0,
        availableSpaceLimitReached: false,
        workspaceLimitReached: false,
        workspaceUsersLimitReached: false,
      },
    },
  };

  constructor() {
    makeObservable(this, {
      currentWorkspace: observable,
    });
  }

  setCurrentWorkspace = (selectedWorkspace: IWorkspace): void => {
    this.currentWorkspace = selectedWorkspace;
  };

  isInRole = (roles: WorkspaceRole[]): boolean => {
    if (!this.currentWorkspace.role) {
      return false;
    }
    return roles.includes(this.currentWorkspace.role);
  };

  get currentWorkspaceTime(): Date {
    const now = getCurrentUTCTime();
    now.setMinutes(now.getMinutes() - this.currentWorkspace.timeZoneOffset);
    return now;
  }
}
